/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { ISocialChannel } from '../social-channel-schema';
import { socialChannelSchema } from '../social-channel-schema';

const setStatusDataSchema = z.object({
  channel: socialChannelSchema,
});

export interface ISetSocialChannelStatusV1Data {
  channel: ISocialChannel;
}

export const setSocialChannelStatusV1ResponseSchema = createApiResponseSchema(
  setStatusDataSchema,
) as z.ZodSchema<IAPI<ISetSocialChannelStatusV1Data>>;

export type ISetSocialChannelStatusV1Response = IAPI<ISetSocialChannelStatusV1Data>;
